import styled from 'styled-components';
import { DataUsageType } from '../modules/cameras/api/dataUsage/types';

type DataUsageCardsProps = {
  data: DataUsageType;
};

export const DataUsageCards = ({ data }: DataUsageCardsProps) => {
  const usedGB = data.totalGB;

  return (
    <TopWrapper>
      <SectionWrapper>
        <TitleCard>Data Used</TitleCard>
        <LargeValue>{usedGB.toFixed(2)} GB</LargeValue>
        <SubText>this month</SubText>
      </SectionWrapper>
      <SectionWrapper>
        <TitleCard>Daily Average</TitleCard>
        <LargeValue>
          {data.daily.length > 0
            ? (usedGB / data.daily.length).toFixed(2)
            : '0.00'}{' '}
          GB
        </LargeValue>
        <SubText>per day</SubText>
      </SectionWrapper>
    </TopWrapper>
  );
};

const TopWrapper = styled.div`
  display: flex;
  gap: 0.75rem;
  width: 100%;
  @media (max-width: 850px) {
    flex-direction: column;
  }
`;

const SectionWrapper = styled.div`
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray900};
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.25rem;
`;

const TitleCard = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.small};
  color: ${({ theme }) => theme.colors.gray500};
  font-weight: 500;
`;

const LargeValue = styled.p`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray900};
`;

const SubText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.extraSmall};
  color: ${({ theme }) => theme.colors.gray500};
`;


